import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import FormatDate from "../../formatdatetime";
import { baseurl } from "../../constant";
import Loading from "../../loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";

const OpenpayoutReport = () => {
  const [data, setdata] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalrecord, settotalrecord] = useState();
  const [startdate, setstartdate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [enddate, setenddate] = useState(
    new Date().toLocaleDateString("en-CA")
  );
  const [keyword, setkeyword] = useState();
  const [status, setstatus] = useState();
  const [loading, setloading] = useState(false);
  const [datalength, setdatalength] = useState();

  const viewall = async () => {
    setstartdate(new Date().toLocaleDateString("en-CA"));
    setenddate(new Date().toLocaleDateString("en-CA"));
    setkeyword();
    setstatus();
    setCurrentPage(1);
    getdata1();
  };

  const search = async () => {
    setCurrentPage(1);
    getdata();
  };

  const token = localStorage.getItem("authToken");
  const pageRecord = 50;
  const totalPage = Math.ceil(totalrecord / pageRecord);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  var pages = [];
  const maxvisablepage = 8;
  if (totalPage <= maxvisablepage) {
    for (let i = 1; i <= totalPage; i++) {
      pages.push(i);
    }
  } else {
    if (currentPage <= 3) {
      // Show first 3 pages, then ellipsis, then last page
      pages.push(1, 2, 3, ".......", totalPage);
    } else if (currentPage >= totalPage - 2) {
      // Show first page, then ellipsis, then last 3 pages
      pages.push(1, totalPage - 2, totalPage - 1, totalPage);
    } else {
      // Show first page, ellipsis, current page & its neighbors, ellipsis, last page
      pages.push(
        1,

        currentPage - 1,
        currentPage,
        currentPage + 1,
        totalPage
      );
    }
  }

  const getdata1 = async () => {
    setloading(true);

    const result = await axios.post(baseurl + "openPayoutReportAuth", {
      token: token,
      pageno: currentPage,
      pageRecord: pageRecord,
      fromDate: new Date(),
      toDate: new Date(),
    });

    setdata(result.data);
    settotalrecord(result.data.totalRecord);
    setdatalength(result.data.data.length);
    setloading(false);
  };

  const getdata = async () => {
    setloading(true);

    const result = await axios.post(baseurl + "openPayoutReportAuth", {
      token: token,
      pageno: currentPage,
      pageRecord: pageRecord,
      fromDate: startdate,
      toDate: enddate,
      keyword: keyword,
      status: status,
    });
    setdata(result.data);
    settotalrecord(result.data.totalRecord);
    setdatalength(result.data.data.length);
    setloading(false);
  };
  useEffect(() => {
    getdata();
  }, [currentPage]);

  const tableRef = useRef(null);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Open Payout report",
    sheet: "Users",
  });

  return (
    <>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <div className="row">
            <div className="col-sm-12">
              <h4>
                <b> Open Money Payout Report</b>
              </h4>
            </div>

            <div className="col-sm-2">
              <select
                className="form-control"
                value={status}
                onChange={(e) => {
                  setstatus(e.target.value);
                }}
              >
                <option value="0">All Status</option>
                <option value="2">Pending</option>
                <option value="3">Success</option>
                <option value="4">Failed</option>
              </select>
            </div>

            <div className="col-sm-2">
              <DatePicker
                className="form-control datepick"
                selected={startdate}
                onChange={(date) => setstartdate(date)}
                dateFormat="yyyy-MM-dd"
                placeholderText={startdate}
              />
            </div>
            <div className="col-sm-2">
              {" "}
              <DatePicker
                className="form-control datepick"
                selected={enddate}
                onChange={(date) => setenddate(date)}
                dateFormat="yyyy-MM-dd"
                placeholderText={enddate}
              />
            </div>

            <div className="col-sm-2">
              <input
                type="text"
                className="form-control"
                placeholder="Keyword"
                name="keyword"
                id="keyword"
                value={keyword}
                onChange={(e) => setkeyword(e.target.value)}
              />
            </div>

            <div className="col-sm-4">
              <button
                type="button"
                className="btn btn-success"
                id="newPayoutSearchBtn"
                onClick={() => search()}
              >
                Search
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  viewall();
                }}
                style={{ margin: "5px" }}
              >
                View All
              </button>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <div class="dt-buttons">
              {" "}
              {/* <button
                class="dt-button buttons-csv buttons-html5"
                tabindex="0"
                aria-controls="newPayoutTransferDataTable"
                type="button"
              >
                <span>CSV</span>
              </button>{" "} */}
              <button
                class="dt-button buttons-excel buttons-html5"
                tabindex="0"
                type="button"
                onClick={onDownload}
              >
                <span>Excel</span>
              </button>{" "}
            </div>
            {loading ? (
              <div>
                <Loading />
              </div>
            ) : (
              <table
                ref={tableRef}
                className="table table-bordered table-striped"
                id="newPayoutTransferDataTable"
                width="100%"
                cellspacing="0"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>MemberID</th>
                    <th>Name</th>
                    <th>Account</th>
                    <th>Amount</th>
                    <th>Txn Type</th>
                    <th>Txn ID</th>
                    <th>RRN</th>
                    <th>Status</th>
                    <th>Date Time</th>
                  </tr>
                </thead>
                <tbody>
                  {datalength > 0 ? (
                    data.data.map((item, index) => (
                      <tr>
                        <td>{(currentPage - 1) * pageRecord + index + 1}</td>
                        <td>{item.user_code}</td>
                        <td>{item.account_holder_name}</td>
                        <td>{item.account_no}</td>
                        <td>
                          Tran. Amount - {item.transfer_amount} <br />
                          Charge - {item.transfer_charge_amount}
                        </td>
                        <td>{item.txnType}</td>
                        <td>{item.transaction_id}</td>
                        <td>{item.rrn}</td>
                        {(item.status == 4 || item.status == 0) && (
                          <td style={{ color: "red" }}>Failed</td>
                        )}
                        {item.status == 2 && (
                          <td style={{ color: "orange" }}>Pending</td>
                        )}
                        {item.status == 3 && (
                          <td style={{ color: "green" }}>Success</td>
                        )}
                        <td>{FormatDate(item.created)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <th colspan="10" style={{ textAlign: "center" }}>
                        There is no data in table
                      </th>
                    </tr>
                  )}
                </tbody>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>MemberID</th>
                    <th>Name</th>
                    <th>Account</th>
                    <th>Amount</th>
                    <th>Txn Type</th>
                    <th>Txn ID</th>
                    <th>RRN</th>
                    <th>Status</th>
                    <th>Date Time</th>
                  </tr>
                </thead>
              </table>
            )}
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage == 1}
              style={{
                padding: "10px 15px",
                margin: "5px",

                border: "1px solid #ccc",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              previous
            </button>

            {pages.map((page, index) => (
              <button
                key={index}
                onClick={() => page !== "..." && handlePageChange(page)}
                style={{
                  padding: "10px 15px",
                  margin: "5px",
                  backgroundColor: currentPage === page ? "red" : "#f0f0f0",
                  color: currentPage === page ? "#fff" : "#000",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  cursor: page === "..." ? "default" : "pointer",
                  fontWeight: page === "..." ? "bold" : "normal",
                }}
                disabled={page === "..."}
              >
                {page}
              </button>
            ))}

            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPage || datalength === 0}
              style={{
                padding: "10px 15px",
                margin: "5px",

                border: "1px solid #ccc",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default OpenpayoutReport;
